import { PathOptions } from "leaflet";

export const neoenergia_pe_untrat = (feature: any): PathOptions => {
  // Unidades de Transformação AT - Dark red circles
  return {
    color: "#990000", // Dark red border
    weight: 1,
    opacity: 1,
    fillColor: "#DD3333", // Medium red fill
    fillOpacity: 0.7,
  };
};
